import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import {
  Image,
  Animation,
  TransTextWithDefault,
  Button,
} from '@starsoft/common/components';
import Reveal from '@/components/core/Reveal';
import { sectionsRefer } from '@/enums/sectionsRefer';
import useNavigateSection from '@/hooks/useNavigateSection';

export default function HomeHeroV2() {
  const { t } = useTranslation('common');
  const { handleNavigate } = useNavigateSection();

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <div className={styles.container__content__column}>
          <div className={styles.container__content__column__heading}>
            <div className={styles.container__content__column__heading__title}>
              <Reveal>
                <TransTextWithDefault text={t('hero__heading')} />
              </Reveal>
            </div>
            <Animation type="fadeInLeft">
              <h2
                className={styles.container__content__column__heading__subtitle}
              >
                {t('hero__description')}
              </h2>
            </Animation>
            <div className={styles.container__content__column__heading__CTA}>
              <Button
                className={
                  styles.container__content__column__heading__CTA__button
                }
                onClick={() => handleNavigate(`#${sectionsRefer.projects}`)}
              >
                {t('games__heading')}
              </Button>
              <Button
                className={`${styles['container__content__column__heading__CTA__button--isSecondary']}
                 ${styles.container__content__column__heading__CTA__button}`}
                onClick={() => handleNavigate(`#${sectionsRefer.solutions}`)}
              >
                {t('solutions__heading')}
              </Button>
            </div>
          </div>
        </div>
        <Animation
          type="fadeInUp"
          className={styles.container__content__column}
        >
          <Image
            src="/banner/banner.png"
            bundle
            alt="home-hero"
            className={styles.container__content__column__image}
          />
        </Animation>
      </div>
    </div>
  );
}
